import script from "./HeaderApp.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderApp.vue?vue&type=script&setup=true&lang=js"

import "./HeaderApp.vue?vue&type=style&index=0&id=2389cf28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2389cf28"]])

export default __exports__